// Types
import type { LineItem } from '../types';
// Helpers
import {
  quantityConverter,
  priceConverter,
  scaleConverter,
} from '../../common';
// Images
import noImage from '../../common/images/noImageChicken.png';

type Props = {
  item: LineItem,
};

const CartBlendPreview = ({ item }: Props) => {
  const price = scaleConverter(item.price, item.lineItems[0].variant.unitForQuantity);
  const listPrice = scaleConverter(
    item.lineItems[0].variant.listPrice,
    item.lineItems[0].variant.unitForQuantity,
  );
  const productOnPromotion = listPrice > price;

  const productImage =
    item.lineItems[0].variant.images && item.lineItems[0].variant.images.length > 0
      ? item.lineItems[0].variant.images[0].smallUrl
      : noImage;

  return (
    <section className="cart-item-preview-main-container">
      <div className="cart-item-preview-product-left-container">
        <div className="cart-item-preview-image-container">
          <div className="cart-item-preview-product-quantity">
            {quantityConverter(item.quantity, item.lineItems[0].variant.unitForQuantity)}
          </div>
          <img
            className="cart-item-preview-product-image"
            src={productImage}
            alt={item.name}
          ></img>
        </div>
        <div className="cart-item-preview-product-content">
          <p>Blend</p>
          <h1>{item.name}</h1>
        </div>
      </div>
      <div className="cart-item-preview-product-price">
        <div
          className={`cart-item-preview-product-price-main ${
            productOnPromotion
              ? 'cart-item-preview-product-price-promotion'
              : ''
          }`}
        >
          <h5>{priceConverter(price)}</h5>
          {productOnPromotion && <h6>{priceConverter(listPrice)}</h6>}
        </div>
      </div>
    </section>
  );
};
export default CartBlendPreview;
